<template>
  <div class="s-amoivaia-calculator">
    <Loader v-if="isLoading" display="absolute"></Loader>
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

    <div class="s-amoivaia-calculator__header">
      <div class="s-amoivaia-calculator__title">
        {{ dictionary.calculatorDataTitle }}
      </div>
      <div
        class="s-amoivaia-calculator__subtitle"
        v-html="dictionary.calculatorDataSubtitle"></div>
    </div>
    <div class="s-amoivaia-calculator__body">
      <div class="s-amoivaia-calculator__body__card">
        <span class="s-amoivaia-calculator__body__card__title">
          {{ dictionary.calculatorDataMonthlyLabel }}
        </span>
        <div>
          <div class="s-amoivaia-calculator__body__card__value">
            <input
              v-model="monthlyDeposit"
              type="text"
              class="s-amoivaia-calculator__body__card__value-input"
              placeholder="30"
              @change="calculate" />
            <span class="s-amoivaia-calculator__body__card__value-suffix">
              {{ dictionary.calculatorDataMonthlySuffix }}
            </span>
          </div>
          <div
            class="s-amoivaia-calculator__body__card__hint"
            :class="{
              empty: !dictionary.calculatorDataMonthlyHint.length,
            }">
            {{ dictionary.calculatorDataMonthlyHint }}
          </div>
        </div>
      </div>

      <div class="s-amoivaia-calculator__body__card">
        <span class="s-amoivaia-calculator__body__card__title">
          {{ dictionary.calculatorDataDurationLabel }}
        </span>
        <div>
          <div class="s-amoivaia-calculator__body__card__value">
            <input
              v-model="duration"
              type="text"
              class="s-amoivaia-calculator__body__card__value-input"
              placeholder="2"
              @change="calculate" />
            <span class="s-amoivaia-calculator__body__card__value-suffix">
              {{ dictionary.calculatorDataDurationSuffix }}
            </span>
          </div>
          <div
            class="s-amoivaia-calculator__body__card__hint"
            :class="{ empty: !dictionary.calculatorDataDurationHint }">
            {{ dictionary.calculatorDataDurationHint }}
          </div>
        </div>
      </div>

      <div class="s-amoivaia-calculator__body__card">
        <span class="s-amoivaia-calculator__body__card__title">
          {{ dictionary.calculatorDataReturnLabel }}
        </span>
        <div>
          <div class="s-amoivaia-calculator__body__card__value">
            <input
              v-model="percentage"
              type="text"
              class="s-amoivaia-calculator__body__card__value-input"
              placeholder="1,5"
              @change="calculate" />
            <span class="s-amoivaia-calculator__body__card__value-suffix">
              {{ dictionary.calculatorDataReturnSuffix }}
            </span>
          </div>
          <div
            class="s-amoivaia-calculator__body__card__hint"
            :class="{ empty: !dictionary.calculatorDataReturnHint }">
            {{ dictionary.calculatorDataReturnHint }}
          </div>
        </div>
      </div>

      <div
        class="s-amoivaia-calculator__body__card s-amoivaia-calculator__body__card--result">
        <span class="s-amoivaia-calculator__body__card__title">
          {{ dictionary.calculatorDataResultsLabel }}
        </span>
        <div>
          <div class="s-amoivaia-calculator__body__card__value">
            <span>{{ result ? result : '-' }}</span>
          </div>
          <div
            class="s-amoivaia-calculator__body__card__hint"
            :class="{
              empty: !dictionary.calculatorDataResultsHint.length,
            }">
            {{ dictionary.calculatorDataResultsHint }}
          </div>
        </div>
      </div>
    </div>
    <div class="s-amoivaia-calculator__footer">
      <div ref="toggleBtn" class="toggleBtn" @click="toggleChange">
        <span>{{ dictionary.calculatorDataConditionsLabel }}</span>
        <i class="icon-chevron-down"></i>
      </div>
      <div
        ref="toggleContent"
        class="toggleContent"
        v-html="conditionsText"></div>
    </div>
  </div>
</template>
<script>
import * as lib from './../../lib/lib'
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'

export default {
  components: {
    Loader,
    Alert,
  },
  data() {
    return {
      // default
      isLoading: false,
      errorMsgs: [],

      monthlyDeposit: null,
      duration: null,
      percentage: null,

      result: '',
      conditionsText: '',
    }
  },
  mounted() {
    const { conditionsText } = lib.getData('amoivaiaCalculatorData')
    this.conditionsText = conditionsText
  },
  methods: {
    calculate() {
      if (this.monthlyDeposit && this.duration && this.percentage) {
        this.fetchData()
      } else {
        this.result = ''
      }
    },

    toggleChange() {
      const toggleBtn = this.$refs.toggleBtn
      const toggleContent = this.$refs.toggleContent
      toggleContent.classList.toggle('show')
      toggleBtn.classList.toggle('active')
    },

    fetchData() {
      this.isLoading = true

      const postData = {
        monthlyDeposit: this.monthlyDeposit,
        duration: this.duration,
        percentage: this.percentage,
        reCaptchaPublicKey: this.configuration.reCaptchaPublicKey,
      }

      axios
        .post(this.configuration.dataHandler, postData)
        .then((response) => {
          const { hasError, errorMessages, data } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          const { result } = data
          this.result = result

          this.$nextTick(() => {
            this.handleSuccess()
          })
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
